import React from "react";

import { Modal } from "src/design-system/Modal";

type SdkScriptModalShellProps = {
  open: boolean;
  title: string;
  onClose: () => void;
};

export const SdkScriptModalShell: React.FC<SdkScriptModalShellProps> = ({
  open,
  title,
  onClose,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>
        <p className="font-inter-normal-13px text-gray-600">
          Script form will be implemented when the API is ready.
        </p>
      </Modal.Content>
    </Modal>
  );
};
